(function ($) {

    // Registered as camcomToggle (not toggle) to avoid overriding jQuery's
    // built-in $.fn.toggle(). The module dispatcher maps 'toggle' → 'camcomToggle'
    // so data-module="toggle" in HTML still works without any template changes.
    $.fn.camcomToggle = function () {

        var elem     = $(this),
            targets  = elem.find('.js-toggle__target'),
            triggers = elem.find('.js-toggle__trigger'),
            settings = {
                activeClass:        'is-active',
                visibleClass:       'is-active',
                elemClass:          '',
                elemClassAttribute: 'data-elem-class'
            };

        var init = function () {

            if (elem.attr(settings.elemClassAttribute)) {
                settings.elemClass = elem.attr(settings.elemClassAttribute);
            }

            triggers.off('click.camcomToggle').on('click.camcomToggle', function (evt) {

                evt.preventDefault();

                var trigger         = $(this),
                    target          = targets.filter(trigger.attr('href')),
                    relatedTriggers = triggers.filter('[href="' + trigger.attr('href') + '"]');

                if (relatedTriggers.length) {
                    trigger = relatedTriggers;
                }

                if (trigger.hasClass(settings.activeClass)) {
                    toggle(trigger, target, 'off');
                } else {
                    toggle(trigger, target, 'on');
                }

            });

        };

        var toggle = function (trigger, target, state) {

            if (state === 'on') {

                target.addClass(settings.visibleClass);
                trigger.addClass(settings.activeClass);

                if (settings.elemClass.length) {
                    elem.addClass(settings.elemClass);
                }

            } else {

                target.removeClass(settings.visibleClass);
                trigger.removeClass(settings.activeClass);

                if (settings.elemClass.length) {
                    elem.removeClass(settings.elemClass);
                }

            }

        };

        init();
        return this;

    };

}(jQuery));
